<template>
    <div class="minidiv">
        <b-modal :id="'modal-remove_'+sn" centered title="Confirm remove" ok ok-variant="success" cancel-variant="danger" @ok="deletenotification()">
            <template v-slot:modal-ok> Yes, Remove </template>
            <p>Are You sure you want to remove {{ content.title }} from Notifications??</p>
        </b-modal>

        <b-modal :id="'modal-preview_'+sn" centered :title="'Preview Notification : ' + content.title">
            <template v-slot:modal-footer>
                <b-link :to="{ name : 'editnotifications', params : { trackid : content.id }}"><b-button class="p-2" variant="info">Edit Notification</b-button></b-link>
                <!-- <b-button class="p-2" variant="success" @click="sendModal()">Send Notification</b-button> -->
            </template> 
            <p class="subject">{{ content.title }}</p>
            <img :src="content.image" class="cover-image"/>
            <div v-html="content.body" class="content-body mt-3"></div>
        </b-modal>

        <div class="flex-parent text-center p-1">
            <p class="flex-child">{{ sn + ((page - 1) * interval) }}</p>
            <p class="flex-child"><b-link @click="$bvModal.show(`modal-preview_${sn}`)">{{ content.title }}</b-link></p>
            <p class="flex-child" v-html="content.body.slice(0, 70)+ '...'"></p>
            <p class="flex-child">{{ content.action }}</p>
            <p class="flex-child"><a :href="content.image" target='_blank'>{{ content.image }}</a></p>
            <p class="flex-child">{{ content.status }}</p>
            <p>
                <b-button :disabled="content.clearance == 'Org Super Admin'" class="p-1 m-1 list-button" variant="danger" @click="comfirmDelete()">Delete</b-button><br>
                <!-- <b-button :disabled="content.clearance == 'Org Super Admin'" class="p-1 M-1 list-button" variant="success" @click="sendModal()">Send</b-button> -->
            </p>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
    props: ["content", 'sn', 'page', 'interval'],
    data() {
        return {
            overallscore: 0,
            send: this.getForm(),
            sending: false,
            sent : false,
        };
    },
    methods: {
        ...mapActions("admin",["delnotification", "fetchNotifications", "sendNotification"]),
        comfirmDelete(){
            this.$bvModal.show(`modal-remove_${this.sn}`);
        },
        sendModal(){
            this.$bvModal.show(`modal-send_${this.sn}`);
        },
        deletenotification(){

            return this.delnotification(this.content.id).then(() => {
                this.fetchNotifications();
            })
        },
        getForm() {
            return {
                target : "all",
                receivers: "all-users",
                timetosend : "now",
                numbers : [],
                emails : [],
                scheduleddate : "",
                trackid : "",
                adminname: "",
                admintrackid: "",
            };
        },
        sendcontent() {
            this.sending = true;
            // this.user.organization = this.details.clearance_organization
            this.send.trackid = this.content.trackid
            this.send.adminname = this.details.fullname
            this.send.admintrackid = this.details.trackid

            return this.sendNotification(this.send).then(() => {
                this.sending = false;
                this.sent = true

                // this.$bvModal.hide(`modal-send_${this.sn}`);

                // this.fetchNotifications();
            });
        },
    },
    computed: {
        ...mapState({
            allinstitutions: state => state.admin.listinstitutions,
            details : state => state.loginmaster.details,
        }),
        chkfields(){
            if( this.sending || this.send.target.length <= 0 ||
                this.send.receivers.length <= 0 || this.send.timetosend.length <= 0){
                return true
            }else{
                return false
            }
        },
    }
};
</script>

<style scoped>
.minidiv {
    border-radius: 10px 10px;
    background-color: white;
    /* padding: 5px; */
}

.rins {
    font-size: 0.75rem;
}

.lowscore {
    color: red;
}

.highscore {
    color: #00377b;
}

.totsco {
    color: #00377b;
    font-weight: bolder;
}

.brel {
    text-decoration: none;
    color: black;
}
.link-sol{
  text-decoration : none;
  color :  #00984a;
}

.flex-parent {
    display: flex;
    flex-flow: row wrap;
    overflow : auto;
    scrollbar-width: thin;
    /* height: 35px; */
}

.flex-child {
    width: 15%;
    overflow : auto;
    scrollbar-width: thin;
}
.cover-image{
    width: 100%;
}
.subject {
    font-size: 2rem;
    font-weight: bold;
}
@media screen and (max-width: 768px) {
     .flex-child{
        font-size: 0.6rem
    }
    .link-sol{
        font-size: 0.7rem
    }
    .list-button{
        width: contain;
        font-size: 0.6rem;
        padding: 3px;
    }
}
</style>
